import {h, Fragment} from "preact"
import { useFacet } from "@nosto/preact"
import { useState } from "preact/hooks"
import Checkbox from "./elements/Checkbox"
import ColorCheckbox from "./elements/ColorCheckbox"
import Icon from "./elements/Icon"

const sizeOrder = ['XXS', 'XS', 'S', 'S-D+', 'M', 'M-D+', 'L', 'L-D+', 'XL', 'XXL', '1X', '2X', '3X']
const coverageOrder = ['cheeky bottom', 'medium bottom', 'full bottom']

export default function Facet({ facet }) {
    const { selectedFiltersCount, toggleActive, toggleProductFilter } = useFacet(facet)
    const [active, setActive] = useState(window.innerWidth > 1024)

    const filterValues = (f) => {
        if(f.name === "Size") {
            return f.data.sort((a, b) => sizeOrder.indexOf(a.value) - sizeOrder.indexOf(b.value));
        } else if(f.name.toString().toLowerCase() === "bottom coverage") {
            return f.data.sort((a, b) => coverageOrder.indexOf(a.value) - coverageOrder.indexOf(b.value));
        } else {
            return f.data;
        }
    }

    const facetData = filterValues(facet);

    return (
        <>
        {facet?.data?.length > 1 &&
        <li class={`ns-sidebar-dropdown ${active ? "ns-active" : ""}`}>
            <a
                class="ns-header-outer ns-d-flex ns-justify-content-between ns-align-items-center ns-relative ns-w-100 ns-border-box ns-text-undecorated"
                href="javascript:void(0)"
                data-nosto-element="facet"
                onClick={() => setActive(!active)}
            >
                <span class="ns-facet-name">{facet.name}</span>
                <span class={`${active ? "" : "ns-d-none"}`}>
                    <svg width="13" height="12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M2.208 6.12h8.824" stroke="currentColor" stroke-miterlimit="10" stroke-linecap="round"></path>
                    </svg>
                </span> 
                <span class={`${active ? "ns-d-none" : ""}`}>
                    <svg width="13" height="12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M6.62 1.708v8.824M2.208 6.12h8.824" stroke="currentColor" stroke-miterlimit="10" stroke-linecap="round"></path>
                    </svg>
                </span>
            </a>
            <div class="ns-sidebar-submenu ns-d-none">
                <ul class={`ns-list-unstyled ns-p-0 ns-m-0 ns-facet-${facet.name}`}>
                    {facetData?.map(value => (
                        <li
                            class="ns-d-block ns-align-items-center ns-filter"
                            data-nosto-element="facet-setting"
                        >
                            {facet.name != 'Color' ?
                                <Checkbox
                                    value={value.value}
                                    selected={value.selected}
                                    count={value.count}
                                    onChange={e => {
                                        e.preventDefault()
                                        toggleProductFilter(facet.field, value.value, !value.selected)
                                    }}
                                /> :
                                (
                                    <ColorCheckbox
                                        value={value.value}
                                        selected={value.selected}
                                        count={value.count}
                                        onChange={e => {
                                            e.preventDefault()
                                            toggleProductFilter(facet.field, value.value, !value.selected)
                                        }}
                                    />
                                )
                            }
                        </li>
                    ))}
                </ul>
            </div>
        </li>
        }
        </>
    )
}
